<template lang="pug">
  .tile.receiver-dashboard.is-vertical-center
    .tile.is-12
      .tile.is-2.is-vertical.create-btn-wrap
        router-link.main-btn.col-white.bg-red(:to="{name: 'CreateJob', params:{lang: getLanguage}}")
          span(@click="showNav = false") {{ gettext('Create new job offer') }}
    .tile.is-12.sender-dashboard-right
      .tile.is-2.is-vertical-center.filters-block
        .is-12.filters(:class="{'open': openFilters}")
          p {{ gettext('Filters by statuses') + ':' }}
          .filter(
          v-for="filter in statuses"
          :class="{'active': currentFilter === filter.id}"
          @click="setFilter(filter.id)"
          ) {{filter.name}}
      .tile.is-10.cvs
        .tile.is-12.is-vertical-center
          .tile.is-12.actions(:class="{'disable': !selectedJobs.length}")
            div(@click="publish(true)") {{ gettext('Publish') }}
            div(@click="publish(false)") {{ gettext('Unpublish') }}
            div(@click="selectedJobs.length ? showDeleteModal = true : showDeleteModal = false") {{ gettext('Delete') }}
          .tile.is-12.table-wrap
            .no-cvs(v-if="!(jobs.items || {}).length")
              .content.is-fluid
                .notification
                  .has-text-centered.is-size-4 {{ gettext('No Vacancies') }}
            .table-wrap-inner(v-else)
              table
                tr.cv
                  td(@click="selectAll")
                    input(type="checkbox" v-model="selectedAll")
                  td #
                  td ID
                  td {{ gettext('Responses') }}
                  td {{ gettext('Status on site') }}
                  td {{ gettext('Workflow status') }}
                  td {{ gettext('Employer') }}
                  td {{ gettext('Country') }}
                  td {{ gettext('Region') }}
                  td {{ gettext('Type of employment') }}
                  td {{ gettext('Profession') }}
                  td {{ gettext('Sector') }}
                  td {{ gettext('Category') }}
                  td {{ gettext('Experience') }}
                  td {{ gettext('Gender') }}
                  td {{ gettext('Languages') }}
                  td {{ gettext('Driving licenses') }}
                  td {{ gettext('Couples') }}
                  td {{ gettext('Accommodation') }}
                  td {{ gettext('Start date') }}
                  td {{ gettext('Salary') }}
                router-link.cv(
                v-for="(job, index) in jobs.items"
                :key="job.id"
                :to="{name: 'EditJob', params: {lang: getLanguage, id: job.id}}"
                )
                  td(@click.prevent="selectJob(job)")
                    input(type="checkbox" v-model="job.checked")
                  td {{ getListNumber(index) }}
                  td {{ job.id }}
                  router-link.responses(v-if="job.all_cvs_number" :to="{name:'JobResponse', params:{lang: getLanguage, id: job.id}, query: {page: 1}}")
                    span {{ job.all_cvs_number + ' / ' }}
                    span.red {{ job.new_cvs_number }}
                  a.responses(v-else)
                    span {{ job.all_cvs_number }}
                  td.status
                    span.on(v-if="job.is_active") {{ gettext('On') }}
                    span.off(v-else) {{ gettext('Off') }}
                  td {{ job.status }}
                  td {{ job.employer }}
                  td {{ job.country.name }}
                  td {{ job.region.name }}
                  td {{ job.employment_type.name }}
                  td {{ (job.profession || {}).name || job.other_profession || '-' }}
                  td {{ job.sector.name }}
                  td {{ job.category.name }}
                  td
                    span(v-if="job.experience_time") {{ job.experience_time.name }}
                    span(v-else) -
                  td
                    span(v-if="job.gender === CONSTANTS.GENDER_NONE") -
                    span(v-if="job.gender === CONSTANTS.GENDER_MALE") {{ gettext('Male') }}
                    span(v-if="job.gender === CONSTANTS.GENDER_FEMALE") {{ gettext('Female') }}
                  td {{ job.languages.map(x => x.name).join(', ') || '-' }}
                  td {{ job.driving_licences.map(x => x.name).join(', ') || '-' }}
                  td {{ job.accept_couples ? gettext('Yes') : gettext('No') }}
                  td {{ job.accommodation ? gettext('Yes') : gettext('No') }}
                  td
                    span.no-text-wrap {{ job.start_date || '-' }}
                  td {{ job.salary }} {{salaryTypeName(job.salary_type)}}
          vue-paginate(
          v-if="jobs.total_items"
          :page-count="jobs.total_pages"
          :page-range="10"
          :initial-page="currentPage-1"
          :clickHandler="toPage"
          )
    v-modal(:show.sync="showDeleteModal" :clickAway="true")
      section.modal-card-body
        .is-size-4.has-text-centered.title {{ gettext('Are you sure want to delete it') }}?
        .btn-wrap
          a.main-btn.col-white.bg-red.nav-item.is-tab(@click="deleteJobs") {{ gettext('Yes') }}
          a.main-btn.col-white.bg-black.nav-item.is-tab(@click="showDeleteModal = false") {{ gettext('No') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { gettext } from '@/services/TranslateHandler'
import VuePaginate from '@/components/paginate'
import VModal from '@/components/modal'

const CONSTANTS = require('@/constants.json')

export default {
  name: 'ReceiverDashboard',
  components: {
    VuePaginate,
    VModal
  },
  data () {
    return {
      openFilters: true,
      currentFilter: null,
      jobs: [],
      pageSize: 10,
      selectedJobs: [],
      selectedAll: false,
      currentPage: parseInt(this.$route.query.page) || 1,
      showDeleteModal: false,
      CONSTANTS: CONSTANTS,
      statuses: {}
    }
  },
  methods: {
    ...mapActions([
      'receiveReceiverVacancies',
      'deleteReceiverVacancies',
      'updateReceiverVacanciesActivity',
      'getReceiverStatuses'
    ]),
    gettext: gettext,
    deleteJobs () {
      this.showDeleteModal = false
      this.deleteReceiverVacancies({data: this.selectedJobs}).then(res => {
        this.getVacancies()
      })
    },
    publish (status) {
      if (!this.selectedJobs.length) return
      this.updateReceiverVacanciesActivity({data: this.selectedJobs, status: status}).then(res => {
        this.getVacancies()
      })
    },
    setFilter (key) {
      if (key === this.currentFilter) {
        this.currentFilter = null
      } else {
        this.currentFilter = key
      }
      this.openFilters = !this.openFilters
      this.getVacancies()
    },
    toPage (page) {
      this.currentPage = +page
      this.getVacancies()
    },
    getVacancies () {
      this.receiveReceiverVacancies({pageNum: this.currentPage, pageSize: this.pageSize, status: this.currentFilter}).then(res => {
        this.jobs = res
        this.selectedJobs = []
        this.selectedAll = false
      })
    },
    getListNumber (index) {
      return (this.currentPage - 1) * this.pageSize + index + 1
    },
    selectJob (job) {
      job.checked = !job.checked
      this.selectedAll = true
      this.$forceUpdate()
      this.updateSelectedJobs()
      if (!this.selectedJobs.length) {
        this.selectedAll = false
      }
    },
    updateSelectedJobs () {
      let arr = []
      this.jobs.items.map(x => {
        if (x.checked) {
          arr.push(x.id)
        }
      })
      this.selectedJobs = arr
    },
    selectAll () {
      this.selectedAll = !this.selectedAll
      let status = this.selectedAll
      this.jobs.items.map(x => {
        x.checked = status
      })
      this.$forceUpdate()
      this.updateSelectedJobs()
    },
    salaryTypeName (code) {
      let types = {
        [CONSTANTS.SALARY_PER_HOUR]: gettext('EUR/Hour'),
        [CONSTANTS.SALARY_PER_DAY]: gettext('EUR/Day'),
        [CONSTANTS.SALARY_PER_WEEK]: gettext('EUR/Week'),
        [CONSTANTS.SALARY_PER_MONTH]: gettext('EUR/Month')
      }
      if (code) return types[code]
      return types[CONSTANTS.SALARY_PER_HOUR]
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ])
  },
  created () {
    this.getReceiverStatuses({lang: this.getLanguage}).then(res => {
      this.statuses = res.items
    })
    this.getVacancies()
  }
}
</script>

<style lang='scss' src='./styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/dashboard/receiver/index.vue